import '../src/styles/globals.css';
import './assets/segoe_ui/style.css';
import {BrowserRouter as Router} from "react-router-dom";
import AppRouter from "../src/router/index";

function App() {
    return (
        <Router>
            <AppRouter/>
        </Router>
    );
}

export default App;
